import styled from 'styled-components'
import { Icon } from 'semantic-ui-react'

export const ThemedIcon = styled(Icon)`
  color: ${props => props.theme.colors.turquoiseGreen};
`
